<template>
  <div class="container">
    <section>
      <img class="title"
           src="../assets/elementary-school-course-title.svg" />
      <CourseDescription class="description"
                         :image="require('../assets/elementary-school-course-description-1.svg')"
                         content="各科課業難題歡迎和老師課後討論，解決問題。" />
      <CourseDescription class="description"
                         :image="require('../assets/elementary-school-course-description-2.svg')"
                         content="未如期到課的同學，歡迎使用視訊補課，老師上課內容、筆記一字不漏。" />
      <CourseDescription class="description"
                         :image="require('../assets/elementary-school-course-description-3.svg')"
                         content="高僑課程採程度分班，一來提升老師教學的效率，二來相近程度的同學們互相切磋可提升學習成效。因此，特定班級需在入班前甄試，並依甄試成績做分班依據（或使用高僑盃競試成績）。
進入課程後，一段時間會有複習考，老師們會依據複習考成績，建議孩子們再往上一階課程學習" />
    </section>
    <nav>
      <router-link to="/course-planning/elementary-school/math">
        數學
      </router-link>
      <router-link to="/course-planning/elementary-school/natural">
        自然
      </router-link>
      <router-link to="/course-planning/elementary-school/chinese">
        國文
      </router-link>
      <router-link to="/course-planning/elementary-school/english">
        英文
      </router-link>
      <router-link to="/course-planning/elementary-school/society">
        社會
      </router-link>
    </nav>
    <router-view class="course-container" />
  </div>
</template>

<script>
import CourseDescription from "@/components/CourseDescription.vue";

export default {
  components: {
    CourseDescription
  }
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 898px;
  margin: auto;

  .title {
    display: block;
    margin: 60px auto;
    width: 135px;
  }

  .description {
    margin: 30px;
  }

  nav {
    margin-top: 60px;
    margin-bottom: 65px;
    display: grid;
    grid-template-areas: ". . . . .";
    justify-content: center;
    grid-gap: 48px;

    a {
      background-color: #f3f3f4;
      border-radius: 14px;
      text-decoration: none;
      color: #6b6b6b;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 40px;

      &.router-link-active,
      &:hover {
        background-color: #c4cb7a;
        color: white;
      }
    }
  }

  .course-container {
    max-width: 700px;
    margin: auto;
    line-height: 1.5rem;
    letter-spacing: 3px;
  }
}

@media (max-width: 480px) {
  .title {
    margin: 20px auto !important;
  }

  .description {
    margin: 10px !important;
  }

  nav {
    grid-gap: 9px !important;
    margin: 20px auto !important;

    a {
      padding: 9px !important;
    }
  }

  .course-container {
    margin: 10px !important;
  }
}
</style>
